export default __webpack_public_path__ + "static/media/james_faul.870ca352.gif";